import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDialogAccount, LazyDialogCommunitySlider, LazyDialogFilters, LazyDialogFrequentlyAskedQuestions, LazyDialogHotspotShop, LazyDialogMegaMenu, LazyDialogPartners, LazyDialogQuickshop, LazyDialogSearchHub, LazyDialogSheerId, LazyDialogShopTheLook, LazyDialogVariantSelection, LazyCmsBloomreachRecommendations, LazyCmsProductRecommendationsStandard, LazyCmsPromoBar, LazyCmsPromoBarMessage, LazyCmsRecommendationCarousel, LazyCmsAccordions, LazyCmsAnchor, LazyCmsArticleGrid, LazyCmsBannerBlockBelow, LazyCmsBannerEspot, LazyCmsBannerImage, LazyCmsBannerImageStandard, LazyCmsBannerMenu, LazyCmsBannerOverlay, LazyCmsBannerSplit, LazyCmsBannerThin, LazyCmsBaseEyebrow, LazyCmsBaseGradient, LazyCmsBaseResponsiveMedia, LazyCmsBenefitBar, LazyCmsCategoryCard, LazyCmsCollection, LazyCmsCollectionStandard, LazyCmsCollectionVerticalList, LazyCmsCtaButtonCollection, LazyCmsCtaButton, LazyCmsDialog, LazyCmsDialogGeneric, LazyCmsExperience, LazyCmsExperiment, LazyCmsFilterBy, LazyCmsFooterItem, LazyCmsHero, LazyCmsHeroBlockBelow, LazyCmsHeroProductOverlay, LazyCmsHeroStandard, LazyCmsIconAndTextCollection, LazyCmsInlineCatalogGrid, LazyCmsLayoutArticle, LazyCmsLinkedCard, LazyCmsMegaMenu, LazyCmsMegaMenuL1, LazyCmsMegaMenuL1Desktop, LazyCmsMegaMenuL1Mobile, LazyCmsMegaMenuL2, LazyCmsMegaMenuL2Desktop, LazyCmsMegaMenuL2Mobile, LazyCmsMegaMenuL3, LazyCmsMegaMenuL3Desktop, LazyCmsMegaMenuL3Mobile, LazyCmsMegaMenuMobile, LazyCmsMegaMenuVisualSelector, LazyCmsMultiLinkCard, LazyCmsPicture, LazyCmsPopUp, LazyCmsPopUpManager, LazyCmsProductRecommendations, LazyCmsProductUpsell, LazyCmsRichText, LazyCmsSecondaryNav, LazyCmsSection, LazyCmsSegmentation, LazyCmsSharedButton, LazyCmsSharedButtons, LazyCmsSharedMedia, LazyCmsSharedMegaMenuCategoryLink, LazyCmsShowcaseControls, LazyCmsShowcaseFrame, LazyCmsShowcaseViewer, LazyCmsSpacer, LazyCmsUgcCuralate, LazyCmsUgcOlapic, LazyCmsUgc, LazyCmsVideoPlayer, LazyCmsVideoCloudinaryPlayer, LazyCmsVideo, LazyDialogContent, LazyDialogAddGiftOption, LazyDialogAddYourPhoto, LazyDialogAskQuestion, LazyDialogAskQuestionSuccess, LazyDialogBopisStoreSearch, LazyDialogCartChangeShippingMethod, LazyDialogCartItemActionMenu, LazyDialogCartValidateShippingAddress, LazyDialogChangeStoreConfirmation, LazyDialogDeleteAddress, LazyDialogDeleteCard, LazyDialogEmployeeTerms, LazyDialogForgotPassword, LazyDialogInterests, LazyDialogKlarna, LazyDialogLocationConfirmation, LazyDialogLoyaltySignUp, LazyDialogMiniCart, LazyDialogNotifyMe, LazyDialogPickupInStore, LazyDialogProductDetailCard, LazyDialogReportIssue, LazyDialogReviewUgc, LazyDialogReviewWrite, LazyDialogReviews, LazyDialogShareYourFavorites, LazyDialogSignIn, LazyDialogSignInConfirmation, LazyDialogSignUp, LazyDialogSimplifiedEnrollment, LazyDialogSizeChart, LazyDialogStoreChanged, LazyDialogTermsAndConditions, LazyDialogThreeDsChallenge, LazyDialogTryItOn, LazyDialogVideo, LazyDialogWelcome, LazyDialogYoutube } from '#components'
const lazyGlobalComponents = [
  ["DialogAccount", LazyDialogAccount],
["DialogCommunitySlider", LazyDialogCommunitySlider],
["DialogFilters", LazyDialogFilters],
["DialogFrequentlyAskedQuestions", LazyDialogFrequentlyAskedQuestions],
["DialogHotspotShop", LazyDialogHotspotShop],
["DialogMegaMenu", LazyDialogMegaMenu],
["DialogPartners", LazyDialogPartners],
["DialogQuickshop", LazyDialogQuickshop],
["DialogSearchHub", LazyDialogSearchHub],
["DialogSheerId", LazyDialogSheerId],
["DialogShopTheLook", LazyDialogShopTheLook],
["DialogVariantSelection", LazyDialogVariantSelection],
["CmsBloomreachRecommendations", LazyCmsBloomreachRecommendations],
["CmsProductRecommendationsStandard", LazyCmsProductRecommendationsStandard],
["CmsPromoBar", LazyCmsPromoBar],
["CmsPromoBarMessage", LazyCmsPromoBarMessage],
["CmsRecommendationCarousel", LazyCmsRecommendationCarousel],
["CmsAccordions", LazyCmsAccordions],
["CmsAnchor", LazyCmsAnchor],
["CmsArticleGrid", LazyCmsArticleGrid],
["CmsBannerBlockBelow", LazyCmsBannerBlockBelow],
["CmsBannerEspot", LazyCmsBannerEspot],
["CmsBannerImage", LazyCmsBannerImage],
["CmsBannerImageStandard", LazyCmsBannerImageStandard],
["CmsBannerMenu", LazyCmsBannerMenu],
["CmsBannerOverlay", LazyCmsBannerOverlay],
["CmsBannerSplit", LazyCmsBannerSplit],
["CmsBannerThin", LazyCmsBannerThin],
["CmsBaseEyebrow", LazyCmsBaseEyebrow],
["CmsBaseGradient", LazyCmsBaseGradient],
["CmsBaseResponsiveMedia", LazyCmsBaseResponsiveMedia],
["CmsBenefitBar", LazyCmsBenefitBar],
["CmsCategoryCard", LazyCmsCategoryCard],
["CmsCollection", LazyCmsCollection],
["CmsCollectionStandard", LazyCmsCollectionStandard],
["CmsCollectionVerticalList", LazyCmsCollectionVerticalList],
["CmsCtaButtonCollection", LazyCmsCtaButtonCollection],
["CmsCtaButton", LazyCmsCtaButton],
["CmsDialog", LazyCmsDialog],
["CmsDialogGeneric", LazyCmsDialogGeneric],
["CmsExperience", LazyCmsExperience],
["CmsExperiment", LazyCmsExperiment],
["CmsFilterBy", LazyCmsFilterBy],
["CmsFooterItem", LazyCmsFooterItem],
["CmsHero", LazyCmsHero],
["CmsHeroBlockBelow", LazyCmsHeroBlockBelow],
["CmsHeroProductOverlay", LazyCmsHeroProductOverlay],
["CmsHeroStandard", LazyCmsHeroStandard],
["CmsIconAndTextCollection", LazyCmsIconAndTextCollection],
["CmsInlineCatalogGrid", LazyCmsInlineCatalogGrid],
["CmsLayoutArticle", LazyCmsLayoutArticle],
["CmsLinkedCard", LazyCmsLinkedCard],
["CmsMegaMenu", LazyCmsMegaMenu],
["CmsMegaMenuL1", LazyCmsMegaMenuL1],
["CmsMegaMenuL1Desktop", LazyCmsMegaMenuL1Desktop],
["CmsMegaMenuL1Mobile", LazyCmsMegaMenuL1Mobile],
["CmsMegaMenuL2", LazyCmsMegaMenuL2],
["CmsMegaMenuL2Desktop", LazyCmsMegaMenuL2Desktop],
["CmsMegaMenuL2Mobile", LazyCmsMegaMenuL2Mobile],
["CmsMegaMenuL3", LazyCmsMegaMenuL3],
["CmsMegaMenuL3Desktop", LazyCmsMegaMenuL3Desktop],
["CmsMegaMenuL3Mobile", LazyCmsMegaMenuL3Mobile],
["CmsMegaMenuMobile", LazyCmsMegaMenuMobile],
["CmsMegaMenuVisualSelector", LazyCmsMegaMenuVisualSelector],
["CmsMultiLinkCard", LazyCmsMultiLinkCard],
["CmsPicture", LazyCmsPicture],
["CmsPopUp", LazyCmsPopUp],
["CmsPopUpManager", LazyCmsPopUpManager],
["CmsProductRecommendations", LazyCmsProductRecommendations],
["CmsProductUpsell", LazyCmsProductUpsell],
["CmsRichText", LazyCmsRichText],
["CmsSecondaryNav", LazyCmsSecondaryNav],
["CmsSection", LazyCmsSection],
["CmsSegmentation", LazyCmsSegmentation],
["CmsSharedButton", LazyCmsSharedButton],
["CmsSharedButtons", LazyCmsSharedButtons],
["CmsSharedMedia", LazyCmsSharedMedia],
["CmsSharedMegaMenuCategoryLink", LazyCmsSharedMegaMenuCategoryLink],
["CmsShowcaseControls", LazyCmsShowcaseControls],
["CmsShowcaseFrame", LazyCmsShowcaseFrame],
["CmsShowcaseViewer", LazyCmsShowcaseViewer],
["CmsSpacer", LazyCmsSpacer],
["CmsUgcCuralate", LazyCmsUgcCuralate],
["CmsUgcOlapic", LazyCmsUgcOlapic],
["CmsUgc", LazyCmsUgc],
["CmsVideoPlayer", LazyCmsVideoPlayer],
["CmsVideoCloudinaryPlayer", LazyCmsVideoCloudinaryPlayer],
["CmsVideo", LazyCmsVideo],
["DialogContent", LazyDialogContent],
["DialogAddGiftOption", LazyDialogAddGiftOption],
["DialogAddYourPhoto", LazyDialogAddYourPhoto],
["DialogAskQuestion", LazyDialogAskQuestion],
["DialogAskQuestionSuccess", LazyDialogAskQuestionSuccess],
["DialogBopisStoreSearch", LazyDialogBopisStoreSearch],
["DialogCartChangeShippingMethod", LazyDialogCartChangeShippingMethod],
["DialogCartItemActionMenu", LazyDialogCartItemActionMenu],
["DialogCartValidateShippingAddress", LazyDialogCartValidateShippingAddress],
["DialogChangeStoreConfirmation", LazyDialogChangeStoreConfirmation],
["DialogDeleteAddress", LazyDialogDeleteAddress],
["DialogDeleteCard", LazyDialogDeleteCard],
["DialogEmployeeTerms", LazyDialogEmployeeTerms],
["DialogForgotPassword", LazyDialogForgotPassword],
["DialogInterests", LazyDialogInterests],
["DialogKlarna", LazyDialogKlarna],
["DialogLocationConfirmation", LazyDialogLocationConfirmation],
["DialogLoyaltySignUp", LazyDialogLoyaltySignUp],
["DialogMiniCart", LazyDialogMiniCart],
["DialogNotifyMe", LazyDialogNotifyMe],
["DialogPickupInStore", LazyDialogPickupInStore],
["DialogProductDetailCard", LazyDialogProductDetailCard],
["DialogReportIssue", LazyDialogReportIssue],
["DialogReviewUgc", LazyDialogReviewUgc],
["DialogReviewWrite", LazyDialogReviewWrite],
["DialogReviews", LazyDialogReviews],
["DialogShareYourFavorites", LazyDialogShareYourFavorites],
["DialogSignIn", LazyDialogSignIn],
["DialogSignInConfirmation", LazyDialogSignInConfirmation],
["DialogSignUp", LazyDialogSignUp],
["DialogSimplifiedEnrollment", LazyDialogSimplifiedEnrollment],
["DialogSizeChart", LazyDialogSizeChart],
["DialogStoreChanged", LazyDialogStoreChanged],
["DialogTermsAndConditions", LazyDialogTermsAndConditions],
["DialogThreeDsChallenge", LazyDialogThreeDsChallenge],
["DialogTryItOn", LazyDialogTryItOn],
["DialogVideo", LazyDialogVideo],
["DialogWelcome", LazyDialogWelcome],
["DialogYoutube", LazyDialogYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
